import React from "react";
import "../css/healthnews.css";
import Navbar from "../Navbar";
import ScrollToTop from "../ScrollToTop";

export default function HealthCare2() {
  return (
    <>
      <Navbar />
      <div className="container" id="white">
        {/* Main Article */}
        <article className="main-article" id="orange">
          <div className="grid-layout">
            {/* Main Content */}
            <div className="main-content">
              {/* Featured Article */}
              <div className="featured-articl">
                
                  <img
                    src="./images/musk-cash.jpg"
                    alt="Business people in a hallway"
                    className="featured-image"
                  />
               
                
                  <h1>
                    Musk election cash giveaways can continue as judge mulls
                    case
                  </h1>
                

                <div className="author-info">
                  <span>By Kelly Phillips Erb</span>
                  <span className="separator">|</span>
                  <span>EI Staff</span>
                </div>
                <div className="news-showcase">
                  <p>
                    {" "}
                    Elon Musk can continue to give away cash to registered
                    voters – for now as a Pennsylvania state judge mulls the
                    case. The Donald Trump supporter has, through his political
                    group America PAC, been offering cash prizes to registered
                    voters in swing states who sign a petition – something US
                    officials suggest may break electoral law. Musk denies
                    this.Philadelphia District Attorney Lawrence Krasner sued
                    Musk this week over the $1m (£770,000) giveaways and said
                    Musk “must be stopped, immediately, before the upcoming
                    presidential election”. At a hearing on Thursday, Judge
                    Angelo Foglietta said the lawsuit will be put on hold while
                    a federal court decides whether to take up the case.If the
                    federal court chooses not to rule on the matter, the case
                    will go back to the state court. In a post on X, the
                    platform Musk owns, he said the ruling was “American Justice
                    FTW (for the win)”.It is unlikely the case will be resolved
                    before Tuesday’s election. “We will proceed to federal court
                    and we will address the issues there and seek to have the
                    matter remanded back to the state court,” John Summers, a
                    lawyer working with Mr Krasner, told reporters after the
                    hearing. “After all, this is a case that involves state law
                    issues,” he added. Philadelphia prosecutor sues Musk over
                    voter lottery Is Musk’s giveaway legal? US election: Follow
                    live coverage Who’s ahead in the polls, Harris or Trump?
                    Musk did not appear at a Philadelphia court for the hearing.
                    The billionaire announced earlier this month that he would
                    randomly award a $1m prize to people in battleground states
                    – Pennsylvania, Georgia, Nevada, Arizona, Wisconsin,
                    Michigan and North Carolina – every day until 5 November.
                    These swing states suggest a particularly close contest
                    between Trump and his Democratic rival for president, Kamala
                    Harris. Yet another winner was announced on Thursday. Musk’s
                    America PAC said Dacey from Fremont, North Carolina had won
                    a $1m check. To be eligible to win, the giveaway requires
                    registered voters to release personal identifying
                    information, like addresses and phone numbers. They are also
                    required to sign a pledge that says they support the US
                    Constitution. The lawsuit filed against Musk claimed he was
                    “running an illegal lottery”. “America PAC and Musk are
                    lulling Philadelphia citizens… to give up their personal
                    identifying information and make a political pledge in
                    exchange for the chance to win $1 million,” Mr Krasner said
                    in the lawsuit. “That is a lottery. And it is indisputably
                    an unlawful lottery.” The lawsuit also accuses the Tesla
                    co-founder of violating consumer protection laws by using
                    “deceptive, vague or misleading statements” that could
                    create confusion. But Musk’s lawyers have argued otherwise.
                    “The complaint, in truth, has little to do with state-law
                    claims of nuisance and consumer protection,” Musk’s lawyers
                    wrote in federal filings, according to a CNN report.
                    “Rather, although disguised as state law claims, the
                    complaint’s focus is to prevent defendants’ purported
                    ‘interference’ with the forthcoming federal presidential
                    election by any means.” Just a day before Judge Foglietta’s
                    ruling, the district attorney’s team asked for enhanced
                    security for the hearing after Musk retweeted a post
                    insulting Krasner that led to threats against him. “It
                    immediately triggered an avalanche of posts from Musk’s
                    followers. Many made antisemitic attacks on Krasner,”
                    Krasner’s team wrote in a legal filing. Before the case was
                    filed, Musk’s PAC was also warned by the US justice
                    department that its lottery-style giveaway might violate
                    federal election law. The BBC has previously reached out to
                    America PAC for comment. Under US law, it is illegal to pay
                    people to register to vote. But legal experts have told the
                    BBC that whether the giveaway violates federal law is a grey
                    area. Musk could face a $10,000 fine and up to five years in
                    prison if a court finds he broke the law. Musk himself, who
                    has been aggressively campaigning for Trump, has insisted
                    voters who want to be eligible for the prizes do not need to
                    register as Republicans or go ahead with casting a vote.
                  </p>
                </div>
              </div>
              {/* Secondary Articles Grid */}
              <div className="secondary-articles">
                {/* Article 1 */}
                <div className="articl">
                  <a href="#">
                    <img src="./images/sr3.png" alt="Capitol building" />
                  </a>
                  <a href="#" className="anchor">
                    <h2>
                      With A Government Shutdown Deadline Looming, IRS Funding
                      Hangs In The Balance
                    </h2>
                  </a>
                  <div className="author-info">
                    By Kelly Phillips Erb | TSD Staff
                  </div>
                </div>
                {/* Article 2 */}
                <div className="articl">
                  <a href="#">
                    <img src="./images/sr3.png" alt="Stock market data" />
                  </a>
                  <a href="#" className="anchor">
                    <h2>
                      America's Top 100 Mid-Cap Stocks: Meet The Companies
                      Powering The AI Boom
                    </h2>
                  </a>

                  <div className="author-info">By Hank Tucker | TSD Staff</div>
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <aside className="sidebar">
              {/* Sidebar Article 1 */}
              <div className="sidebar-article">
                <a href="#">
                  <img src="./images/sr3.png" alt="Tax document review" />
                </a>
                <a href="#" className="anchor">
                  <h2>We Need A Big, Fat Tax Cut Fast</h2>
                </a>
                <div className="author-info">By Steve Forbes | TSD Staff</div>
              </div>
              {/* Sidebar Article 2 */}
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/sr3.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/sr3.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/sr3.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
            </aside>
          </div>
        </article>
      </div>
      <ScrollToTop />
    </>
  );
}
